import { isNumber } from '@/helpers/common';

export default {
  params: ['maxYears'],
  validate (yearsLived, { maxYears }) {
    return {
      required: true,
      valid: isNumber(yearsLived) &&
        (yearsLived >= Number(this.constants.PROPERTY_YEARS_LIVED_MIN)) &&
        (yearsLived <= Number(this.constants.PROPERTY_YEARS_LIVED_MAX)) &&
        (yearsLived <= Number(maxYears)),
    };
  },
  message: (fieldName, { _value_: yearsLived, maxYears }) => {
    if ((yearsLived > Number(maxYears))) {
      return 'Please check: You cannot have lived in the property before it was built.';
    }

    return 'Please enter a number e.g. 10';
  },
  computesRequired: true,
};
